<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
         <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-large
        rounded="sm"
      >
      <!-- Register v1 -->
      <b-card class="mb-0">

        <b-link class="brand-logo">
          <h2 class="brand-text text-primary ml-1">
            CloudFit Pro
          </h2>
        </b-link>

        <b-card-title class="mb-1 text-center">
         登記信用卡
        </b-card-title>
        <b-card-text class="mb-2 text-center">
            <div v-if="status === 'step2'">
                <h2 class="text-warning">請稍後</h2>
                <br>
                <h3>正在處理中....</h3>
                <h5 class="text-danger">請勿離開或重新載入此畫面</h5>
            </div>
            <div v-if="status === 'success'">
                <h2 class="text-success">已經成功登記</h2>
                <br>
                <h5>你可以隨時關閉這個視窗</h5>
            </div>
            <div v-else-if="status === 'failed'">
                <h2 class="text-danger">登記失敗</h2>
                <br>
                <h5>請重新再試，或聯絡我們的支援團隊</h5>
            </div>
            </b-card-text>
      </b-card>
    <!-- /Register v1 -->
     </b-overlay>
    </div>
  </div>

</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BLink, BCardTitle, BCardText, BForm,BOverlay,
  BButton, BFormInput, BFormGroup, BInputGroup, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
import router from '@/router'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    VuexyLogo,
    // BSV
    BCard,
    BOverlay,
    BLink,
    BCardTitle,
    router,
    BCardText,
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status : router.currentRoute.params.status,
      loading:false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  created() {
    if (this.status == 'step2') {
      this.purchase()
    }
  },
  methods: {
    purchase() {
      this.loading = true
        this.$http.post(process.env.VUE_APP_API_BASE+`/paylink/bbmsl/pay/`, {
          item_type : router.currentRoute.query.item_type,
          item_id : +router.currentRoute.query.item_id
        })
          .then(res => {
            if (res.data.result.responseCode == '0000') {
              this.loading = false
              this.status = 'success'
            } else {
              this.loading = false
              this.$toast({
                component: ToastificationContent,
                position: 'top-center',
                props: {
                  title: 'Error',
                  icon: 'XIcon',
                  variant: 'danger',
                  text: res.data.result.message,
                },
              })
            }
          })
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
